module.exports = __webpack_public_path__ + "img/features_header_inventaris.15c51fec.png";